module.exports = __webpack_public_path__ + "img/581.4d4d081a.jpg";